import React, { useEffect, useRef } from "react";
import { func } from "prop-types";
import { useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { DateRangeField } from "pages/_components/fields/DateRangeField";
import Selector from "pages/_components/fields/formik/Selector";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { discountStates } from "util/discounts";
import { getLimitDate } from "util/date";
import * as i18n from "util/i18n";

const FORM_ID = "discounts";

const FilterForm = ({ setOpenSidebar, setFilters }) => {
    const formRef = useRef(null);
    const { discountFilters } = useSelector((state) => state.discounts);

    const initialValues = {
        status: "",
        idBatch: "",
        dateRange: [null, null],
    };

    const statesOptions = [{ value: "", label: "Todos" }, ...discountStates];

    useEffect(() => {
        if (!formRef.current) {
            return;
        }

        const filtersTags = Object.entries(discountFilters);
        filtersTags.forEach((item) => {
            if (item[0] === "dateFrom") {
                formRef.current.setFieldValue("dateRange[0]", item[1] ?? null);
            }
            if (item[0] === "dateTo") {
                formRef.current.setFieldValue("dateRange[1]", item[1] ?? null);
            }
            formRef.current.setFieldValue(item[0], item[1]);
        });
    }, [discountFilters]);

    const handleSubmit = (values) => {
        if ((!!values.dateRange[0] && !values.dateRange[1]) || (!values.dateRange[0] && !!values.dateRange[1])) {
            formRef.current.setErrors({
                dateRange: i18n.get("", "Debe ingresar un rango de fechas"),
            });
            return;
        }
        formRef.current.setErrors({
            dateRange: null,
        });

        const finalDateTo = values.dateRange[1]
            ? new Date(new Date(values.dateRange[1])?.setHours(20, 59, 59, 999))
            : null;

        const requestFilters = {
            ...discountFilters,
            status: values.status,
            dateFrom: values.dateRange[0],
            dateTo: finalDateTo,
            idBatch: values.idBatch,
            typePayment: "PH",
        };
        setFilters(requestFilters);

        setOpenSidebar((state) => !state);
    };

    const handleReset = () => {
        formRef.current.setFieldValue("status", "");
        formRef.current.setFieldValue("dateRange", [null, null]);
        formRef.current.setFieldValue("idBatch", "");
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleSubmit} ref={formRef}>
            <Form>
                <Row>
                    <Col xs={12} md={6}>
                        <Field
                            component={DateRangeField}
                            placeholder
                            idForm={FORM_ID}
                            minDate={getLimitDate(-184)}
                            maxDate={getLimitDate(0)}
                            name="dateRange"
                            dateFormat="dd/MM/yyyy"
                            selectsRange
                            showMonthYearDropdown
                            scrollableMonthYearDropdown
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field
                            component={TextField}
                            labelTextDefault={i18n.get("discounts.tableHeader.idBatch")}
                            placeholderText={i18n.get("forms.bankselector.search")}
                            idForm={FORM_ID}
                            name="idBatch"
                            type="text"
                            /* pattern="[0.0-9.9]*"
                            maxLength={11}
                            minLength={0} */
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <Field
                            idForm={FORM_ID}
                            name="status"
                            component={Selector}
                            options={statesOptions}
                            placeholder={i18n.get("parties.placeholder.todos")}
                        />
                    </Col>
                </Row>
                <Row className="form-actions">
                    <Col xs={12} md={6}>
                        <Button className="btn-outline" label="echecks.clean.filters" onClick={handleReset} />
                    </Col>
                    <Col xs={12} md={6}>
                        <Button type="submit" className="btn-primary" label="echecks.filtering" />
                    </Col>
                </Row>
            </Form>
        </Formik>
    );
};

FilterForm.propTypes = {
    setFilters: func.isRequired,
    setOpenSidebar: func.isRequired,
};

export default FilterForm;
